import { createStore } from '@store/createStore';

const useSensorViewedStore = createStore(
  (set) => ({
    lastViewedSensorId: null,

    actions: {
      setLastViewedSensorId: (lastViewedSensorId) => set({ lastViewedSensorId }),
    },
  }),
  'sensorViewedStore',
);

export const useSensorViewedStoreActions = () => useSensorViewedStore((state) => state.actions);

export const selectLastViewedSensorId = () => useSensorViewedStore((state) => state.lastViewedSensorId);
